import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {types, endpoints} from 'main/tools';

class SurveysPageState {
  store = new DomainStore();

  scope;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.PAYROLL.NAVIGATION
    ]);

    this.scope = this.store._getSingle(types.NAVIGATION_SCOPE).tabs;
  }
}

export default SurveysPageState;
